export const JUVO = '© Copyright Juvo Utilis 2020';
export const VERSAO = 'Versão: 0.3';
